import { SportsNameType } from "app/utils/const";
import * as api from "../../api/sportsSelectionApi";

/**
 * reducers: `myFunc(state, payload)`
 * effects:  `async myFunc(payload, rootState)`
 */
const SportsSelectionListModel = {
  state: {
    sportsSelectionList: [] as Array<any>,
    selectedSportName: "Soccer",
    translatedSportName: "Soccer",
    selectedSportTimeFrame: "TODAY",
    selectedMarketType: "HANDICAP",
    selectedMarketName: "HDP & O/U",
    total: 0,
    defaultId: null,
    sportNavNodeId: null,
    sportsSelectionLoaded: false,
    displayDraw: true,
  },
  reducers: {
    // Update one or more properties
    // eg payload
    // [
    //   {
    //     selectedMarketType: MarketTypes.OUTRIGHT,
    //   },
    //   {
    //     selectedSportName: sportName,
    //   },
    //  ]

    set(state, payload: { [key: string]: boolean | string | null }[]) {
      const newState = { ...state };
      // Update state for each key value pair in the payload
      payload.forEach(filter => {
        for (const [key, value] of Object.entries(filter)) {
          newState[key] = value;
        }
      });

      return newState;
    },
    resetList: (state: Record<string, any>): any => {
      return {
        ...state,
        sportsSelectionList: [],
        selectedSportName: "Soccer",
        translatedSportName: "Soccer",
        selectedSportTimeFrame: "",
        selectedMarketType: "HANDICAP",
        selectedMarketName: "HDP & O/U",
        defaultId: null,
        sportNavNodeId: null,
      };
    },
    setSportsSelection: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return {
        ...state,
        sportsSelectionList: payload.sportsSelectionList,
        total: payload.total,
        defaultId: payload.defaultId,
        sportsSelectionLoaded: true,
      };
    },
    setSelectedSportInfo: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return {
        ...state,
        selectedSportName: payload.selectedSportName,
        translatedSportName: payload.translatedSportName,
        selectedSportTimeFrame: payload.selectedSportTimeFrame,
        defaultId: payload.defaultId,
        selectedMarketType: payload.selectedMarketType,
        selectedMarketName: payload.selectedMarketName,
        sportNavNodeId: payload.sportNavNodeId,
        displayDraw: payload.displayDraw,
        translatedMarketName: payload.translatedMarketName,
      };
    },
  },
  effects: {
    /**
     * payload: { }
     */
    async updateSportsSelection(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      const { after, before } = payload;
      const sportName = rootState.sportsSelectionListModel.selectedSportName;
      const displayDraw = rootState.sportsSelectionListModel.displayDraw;

      //
      return api
        .fetchSportsSelectionList({
          after: after,
          before: before,
        })
        .then((data: any) => {
          let name = sportName;

          const sportsSelectionList = data["sportNumberOfEventsDescriptions"];
          // Commenting the following because it doesn't seem to be needed
          // and is getting executed on every poll of /asian/sportsNumberOfEvents
          // Uncommenting the following as it is needed :-)
          // *** START
          // step to set default translated sport name on initial load
          if (
            name &&
            name.toLowerCase() === SportsNameType.SOCCER.toLowerCase() &&
            sportsSelectionList !== undefined &&
            sportsSelectionList.length > 0
          ) {
            this.setSelectedSportInfo({
              selectedSportName: sportsSelectionList[0]["sportName"],
              translatedSportName:
                sportsSelectionList[0]["translatedSportName"],
              selectedSportTimeFrame:
                rootState.sportsSelectionListModel.selectedSportTimeFrame,
              selectedMarketType:
                rootState.sportsSelectionListModel.selectedMarketType,
              selectedMarketName:
                rootState.sportsSelectionListModel.selectedMarketName,
              defaultId: sportsSelectionList[0]["sportNavNodeId"],
              sportNavNodeId: sportsSelectionList[0]["sportNavNodeId"],
              displayDraw: displayDraw,
            });
          }
          // *** END

          const defaultId =
            sportsSelectionList !== undefined && sportsSelectionList.length > 0
              ? sportsSelectionList[0]["sportNavNodeId"]
              : 1;
          this.setSportsSelection({
            sportsSelectionList: sportsSelectionList,
            total: data.total,
            defaultId: defaultId,
          });
        })
        .catch(error => {
          throw error;
        });
    },
  },
};
export default SportsSelectionListModel;
